<script>
export default {
  methods: {
    handleError(error, options = {}) {
      // vue-notification schema
      let errorMessage = {
        group: "main",
        type: "error",
        title: "Oups",
        text: "Pas de connexion",
        duration: 5000
      };

      const ErrorMessages = {
        400: "",
        401: "",
        403: "",
        405: "",
        500: "Erreur serveur, réessayez plus tard",
        request: "",
        other: ""
      };

      // Setup error message
      if (error) {
        errorMessage.text = error;

        if (error.hasOwnProperty("message")) {
          errorMessage.text = error.message;
        }

        if (error.response) {
          switch (error.response.status) {
            case 500:
              errorMessage.text = ErrorMessages["500"];
              break;

            default:
              break;
          }

          // Trying to use server error message
          if (
            error.hasOwnProperty("response") &&
            error.response.hasOwnProperty("data")
          ) {
            if (
              error.response.data.hasOwnProperty("message") &&
              error.response.data.message.length > 0
            ) {
              // Log to server
              errorMessage.text = error.response.data.message;
            }
          }
        }
      }

      errorMessage = { ...errorMessage, ...options };

      this.$notify(errorMessage);
    }
  }
};
</script>
